import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, loading, isAdmin } = useAuth();

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Si la route nécessite les privilèges admin et que l'utilisateur n'est pas admin
  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" />;
  }

  // Si tout est OK, afficher le composant enfant
  return children;
};

export default ProtectedRoute;